import { GridCustomCellProps } from "@progress/kendo-react-grid";
import { AttendanceStatus } from "../../../data/entities";
import { to12HourTime } from "../../../utils";

export const AppointmentDateCell = (props: GridCustomCellProps) => {
  const unformattedDate = props.dataItem.date;
  if (!unformattedDate) return <td {...props.tdProps}>—</td>;

  const datePart = String(unformattedDate).split("T")[0];
  const date = new Date(`${datePart}T00:00:00`);
  if (isNaN(date.getTime())) return <td {...props.tdProps}>Invalid</td>;

  return <td {...props.tdProps}>{date.toLocaleDateString()}</td>;
};

export const AppointmentTimeCell = (props: GridCustomCellProps) => {
  const { startTime, endTime } = props.dataItem;
  const start = to12HourTime(startTime);
  const end = to12HourTime(endTime);
  return <td {...props.tdProps}>{start && end ? `${start} – ${end}` : start || end || "—"}</td>;
};

export const ClientNameCell = (props: GridCustomCellProps) => {
  const { customerFirstName, customerLastName } = props.dataItem;
  const name = `${customerFirstName ?? ""} ${customerLastName ?? ""}`.trim();
  return <td {...props.tdProps}>{name}</td>;
};

const softBadgeStyle = (color: "primary" | "success" | "danger" | "warning" | "secondary") => ({
  backgroundColor: `rgba(var(--bs-${color}-rgb), 0.1)`,
  color: color === "warning" ? "var(--bs-warning-text-emphasis, #997404)" : `var(--bs-${color})`,
  borderColor: `rgba(var(--bs-${color}-rgb), 0.35)`,
});

const SoftBadge = ({ color, children }: { color: Parameters<typeof softBadgeStyle>[0]; children: string }) => (
  <span className="badge border" style={softBadgeStyle(color)}>{children}</span>
);

export const AttendanceStatusCell = (props: GridCustomCellProps) => {
  const { attendanceStatus, isCancelled } = props.dataItem;

  if (isCancelled) {
    return <td {...props.tdProps}><SoftBadge color="warning">Cancelled</SoftBadge></td>;
  }

  switch (attendanceStatus) {
    case AttendanceStatus.NoShow:
      return <td {...props.tdProps}><SoftBadge color="danger">No-show</SoftBadge></td>;
    case AttendanceStatus.CheckedIn:
      return <td {...props.tdProps}><SoftBadge color="success">Checked in</SoftBadge></td>;
    default:
      return <td {...props.tdProps}><SoftBadge color="primary">Booked</SoftBadge></td>;
  }
};
